import {topupSvg as Icon__small__topupSvg} from '../Icon__small/Icon__small--topup.js'

export var topup = {
  name: 'topup',
  category: 'icon',
  colorable: true,
  svg: Icon__small__topupSvg,
};
